export class GetCatalogSetupRequest {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "sourceType",
            "baseName": "sourceType",
            "type": "FederatedSourceType",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return GetCatalogSetupRequest.attributeTypeMap;
    }
    constructor() {
    }
}
